import { FC, memo } from "react";
// Redux
import { useAppSelector } from "hooks/useStore";
// Selectors
import { selectExpertCurrectScore, selectMaxScore, selectTotalScore } from "store/player/playerSelectors";
import { selectQuiz } from "store/quiz/quizSelectors";

const expertColor = '#ffb347';

const BeatTheExpertQuestionProgress:FC = () => {
  const quiz = useAppSelector(selectQuiz);
  const totalScore = useAppSelector(selectTotalScore);
  const maxScore = useAppSelector(selectMaxScore);
  const expertScore = useAppSelector(selectExpertCurrectScore)

  const playerWidth = (totalScore / maxScore) * 100;
  const expertWidth = (expertScore / maxScore) * 100;

  return (
    <div className="p-4">
      <div className="shadow-primary border border-[rgb(60,57,60)] rounded-2xl p-2 bg-black">
        <div className="relative mb-1 bg-[rgb(36,36,36)] rounded-lg px-2 flex items-center justify-between">
          <p className="font-bold text-lg text-white z-10">You</p>
          <div
            className="absolute top-0 left-0 h-full rounded-lg"
            style={{ backgroundColor: quiz.theme.progressBarColor, width: `${playerWidth}%`, transition: 'width 0.5s ease-in-out' }}
          />
          <p className="font-bold text-lg text-white z-10">{totalScore.toLocaleString('en-US')}</p>
        </div>
        <div className="relative mb-1 bg-[rgb(36,36,36)] rounded-lg px-2 flex items-center justify-between">
          <p className="font-bold text-lg text-white z-10">Expert</p>
          <div
            className="absolute top-0 left-0 h-full rounded-lg"
            style={{ backgroundColor: expertColor, width: `${expertWidth}%`, transition: 'width 0.5s ease-in-out' }}
          />
          <p className="font-bold text-lg text-white z-10">{expertScore.toLocaleString('en-US')}</p>
        </div>
      </div>
    </div>
  );
};

export default memo(BeatTheExpertQuestionProgress);
